define('views/user/register/financial/productselection',["backbone",
         "text!views/user/register/financial/productselection.html",
         "views/_base/baseview",
        "views/user/register/financial/memberapplication",
        "views/accounts/linknewcard/linknewcard",
        "views/accounts/getdebitcard",
], function (Backbone, Template, BaseView, FinancialRegView, LinkCardView, GetDebitCardView) {
    "use strict";

    return BaseView.extend({
        id       : "productSelection",
        isRender : true,
        needsAuth: true,
        template : _.template(Template),
        events   : {
            "click #linkVisa": "showSelectedproduct",
            "click #getDebit": "showSelectedproduct"
        },

        initialize: function (options) {
            options = options || {};

            var that = this;
            that.isRegistration = 0;
            store.getStoreItem(enums.modelsEnum.IsRegistration, null, false, false, false, function (data) {
                that.isRegistration = data;
            });

            this.elementName = options.elementName;
            BaseView.prototype.initialize(this);
        },

        render: function () {
            this.$el.html(this.template());
            
            this.showMainHeader();
            this.delegateEvents();
            return this;
        },

        showMainHeader: function(){
            $('#mainHeaderWrap').css('display','block');
        },
        
        getDebit: function() {
            var that = this;
            if (pf.session.get("CardType") != enums.cardTypes.GPRDebitCard) {
                $.ajax({
                    type: "POST",
                    url: pf.accountsURL + "/ConvertToGPR",
                    async: true,
                    contentType: "application/json; charset=utf-8",
                    traditional: true,
                    success: function (response) {
                        if (response) {
                            pf.session.set({ CardType: enums.cardTypes.GPRDebitCard });

                            //Navigate to success page
                            pf.require("views/user/register/financial/success", null, null, true, function () {
                                require(["views/user/register/financial/success"], function (SuccessView) {
                                    pf.show(new SuccessView({ elementName: "#mainRegion" }));
                                });
                            });
                        } else {
                            jAlert("There was an error trying to request a debit card. Please try again")
                        }
                    },
                    error: function (resp,model) {
                        if (resp.status == 400) {
                            jAlert("There was an error trying to request a debit card. Please try again")
                        }
                    },
                    done: function (response) {
                        if (response) {
                            pf.session.set({ CardType: enums.cardTypes.GPRDebitCard });

                            //Navigate to success page
                            pf.require("views/user/register/financial/success", null, null, true, function () {
                                require(["views/user/register/financial/success"], function (SuccessView) {
                                    pf.show(new SuccessView({ elementName: "#mainRegion" }));
                                });
                            });
                        } else {
                            jAlert("There was an error trying to request a debit card. Please try again")
                        }
                    }
                });
            } else {
                //Navigate to success page
                pf.require("views/user/register/financial/success", null, null, true, function () {
                    require(["views/user/register/financial/success"], function (SuccessView) {
                        pf.show(new SuccessView({ elementName: "#mainRegion" }));
                    });
                });
            }
        },

        showSelectedproduct: function(e) {
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            switch(e.target.id) {
                case 'linkVisa':
                    var linkCardView = new LinkCardView({
                        elementName: "#mainRegion",
                        isRegistrationFlow: true
                    });
                    pf.show(linkCardView);
                    break;
                case 'getDebit':
                    var debitCardView = new GetDebitCardView({
                        elementName: "#mainRegion",
                        showLinkedCardSuccess: false,
                        isModal: false
                    });
                    pf.show(debitCardView);
            }



            // var product = 0;
            // if (e.target.id == "linkVisa")
            //     product = enums.cardTypes.VirtualCard;
            // if (e.target.id == "getDebit")
            //     product = enums.cardTypes.GPRDebitCard;

            //var financialRegView = new FinancialRegView({ elementName: "#mainRegion", product: product });
            //pf.show(financialRegView);

            // pf.require("views/user/register/financial/memberapplication", null, null, true, function () {
            //     require(["views/user/register/financial/memberapplication"], function (FinancialRegView) {
            //         pf.show(new FinancialRegView({ elementName: "#mainRegion", product: product }));
            //     });
            // });
        },

        close: function(){}
    });
});

